module.exports = __webpack_public_path__ + "img/Approved.804fa988.svg";